/** Package 4, part L (owner, 7. 10. 2026): sound and Danny Dawn's radio. */
export default {
  sound: {
    mute: 'Mute sound',
    unmute: 'Sound on',
    title: 'Sound',
    sub: 'Sounds stay on this device. Music and ambience start quiet.',
    muted: 'Mute everything',
    mutedSub: 'The button in the top bar does the same.',
    effects: 'Effects',
    effectsSub: 'Reports, loot, level up, crafts, rewards',
    music: 'Music',
    musicSub: 'The Camp, the horde, the season’s end',
    ambient: 'Ambience',
    ambientSub: 'The fire at camp, the wind on the map, the horde',
    radio: 'Radio',
    radioSub: 'Danny Dawn’s jingle and the static',
    temporary: 'These are stand-in sounds until the real ones are recorded.',
  },
  card: {
    label: 'Station 9 radio',
    title: 'Danny Dawn',
    morning: 'Morning broadcast · {time}',
    evening: 'Evening broadcast · {time}',
    none: 'Nothing on the air yet. Danny is on at 08:00 and 18:30.',
    listen: 'Listen',
    new: 'New',
    next: 'Next broadcast {time}',
  },
  /** 8. 10. 2026 (owner): the season's finale. */
  finale: {
    label: 'Season finale',
    title: 'Last Broadcast',
    body: 'Danny needs Electronics to fix the Station 9 relay for his last broadcast of the season ({time}). Everyone brings some: {per} for every survivor out there this week.',
    reached: 'The relay is fixed. Danny’s last broadcast airs {time}. Bring some too and you are on the list for the title.',
    aired: 'Danny’s last broadcast went out over the whole city. Everyone who helped has the title Last Broadcast.',
    static: 'The relay never got enough Electronics. Static took Danny’s last broadcast.',
    progress: '{total} of {goal} Electronics · {helpers} helped · {active} survivors out this week',
    mine: 'You brought {n}. The title {title} is yours if the relay works.',
    give: 'Bring {n}',
    have: '{n} in Storage',
  },
  sheet: {
    title: 'Station 9 radio',
    onAir: 'On the air',
    under: 'Under the static',
    archive: 'Earlier broadcasts',
    archiveEmpty: 'No earlier broadcasts yet.',
    close: 'Turn it off',
  },
};
